/* global Shopify */
class Footer {
    constructor() {
        let footer = document.querySelector('footer');

        this.elements = {
            menu: footer.querySelectorAll('#footer-menu details'),
            igbox: document.querySelector('#instagram-box'),
        };

        this.init();
    }

    init() {
        this.elements.menu.forEach(
            detail => {
                detail.addEventListener('toggle', (e) => {
                    if (detail.open && this.isMobileDisplay) {
                        this.elements.menu.forEach(
                            detail_sibling => {
                                if (detail_sibling !== e.target) {
                                    detail_sibling.open = false;
                                }
                            }
                        );
                    }
                });
            }
        );

        window.addEventListener('resize', () => {
            if (this.isMobileDisplay !== Shopify.isMobileDisplay()) {
                this.checkMenuMobile();
            }
        });

        this.checkMenuMobile();

        setTimeout(() => {
            this.populateInstagramBox();
        }, 1000);
    }

    checkMenuMobile() {
        let counter = 1;

        this.isMobileDisplay = Shopify.isMobileDisplay();

        this.elements.menu.forEach(
            detail => {
                if (Shopify.isMobileDisplay()) {
                    detail.open = counter++ <= 1;
                } else {
                    detail.open = true;
                }
            });
    }

    populateInstagramBox() {
        let slider = '';
        let images = this.elements.igbox.querySelectorAll('.instagram-grid-container img');

        if (images.length === 0) {
            return;
        }

        let logo = document.getElementById('i-logo').innerHTML;
        let link = this.elements.igbox.querySelector('#i-title > a').href;

        for (let i = 0; i < images.length; i++) {
            slider += `<div><a href ="${link}" target="_blank"><div>${logo}` +
                `<img src="${images[i].src}" width="296" height="296" data-aos="fade" data-aos-delay="${i * 50}"/></div>` +
                `</a></div>`;
        }
        document.getElementById('instagram-feed').innerHTML = slider;

        setTimeout(() => {
            // slick slider ig
            $('#instagram-feed').slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                centerMode: true,
                centerPadding: "20%",
                prevArrow: document.getElementById('i-arrow-left'),
                nextArrow: document.getElementById('i-arrow-right'),
                appendArrows: '.instagram-arrow',
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        centerMode: false,
                        slidesToShow: 6,
                        slidesToScroll: 6,
                    }
                }]
            });

            document.getElementById('instagram-box').hidden = false;

            /* global AOS */
            AOS.init({
                duration: 600,
                easing: 'ease-out',
            });
        }, 400);
    }
}

Shopify.footer = new Footer();
